module.exports = __webpack_public_path__ + "img/1234567896.857695a9.png";